import { ApiError } from '../../utils/apiClient';

export type MemberErrorKind =
  | 'duplicate'
  | 'forbidden'
  | 'invalid'
  | 'notFound'
  | 'network'
  | 'generic';

// The backend replaces the role of an existing member and never reports a
// duplicate, so the frontend has to detect it before it sends the request.
export class DuplicateMemberError extends Error {
  constructor() {
    super('The user is already a member of this project');
    this.name = 'DuplicateMemberError';
  }
}

export function classifyMemberError(error: unknown): MemberErrorKind {
  if (error instanceof DuplicateMemberError) return 'duplicate';
  if (!(error instanceof ApiError)) return 'generic';
  switch (error.status) {
    case 400:
      return 'invalid';
    case 403:
      return 'forbidden';
    case 404:
      return 'notFound';
    case 0:
      return 'network';
    default:
      return 'generic';
  }
}
